import { Button } from '@eventbrite/eds-button';
import React from 'react';

export interface CtaButtonInterface {
    buttonUrl: string;
    buttonText: string;
    buttonClasses?: string;
}

class CtaButton extends React.PureComponent<CtaButtonInterface> {
    render() {
        const { buttonText, buttonUrl, buttonClasses } = this.props;
        return (
            <div className="eds-g-cell eds-g-cell-12-12 mktg-button-overlap cta-margin-top">
                <a href={buttonUrl}>
                    <Button style="fill" __containerClassName={buttonClasses}>
                        {buttonText}
                    </Button>
                </a>
            </div>
        );
    }
}

export default CtaButton;
